import React, { Component } from 'react';

import ModalDetalle from "./ModalDetalle.js";

import ParadigmaTable from "../../../components/ParadigmaTable/";
import api from "../../../api";

import { format } from '../../../functions/functions';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker";

class MovimientosAgrupados extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Loteo",
                    id: "loteoNombre",
                    accessor: d => d.loteoNombre, 
                    show: true,
                    exportWidth: "70",
                },
                {
                    Header: "Loteo_id",
                    id: "loteo_id",
                    accessor: d => d.loteo_id, 
                    show: false,
                    private: true,
                    // exportWidth: "70",
                },
                {
                    Header: "Lote",
                    id: "loteNombre",
                    accessor: d => d.loteNombre, 
                    show: true,
                    exportWidth: "30",
                },
                {
                    Header: "Lote_id",
                    id: "lote_id",
                    accessor: d => d.lote_id, 
                    show: false,
                    private: true,
                    // exportWidth: "30",
                },
                {
                    Header: "Tipo",
                    id: "tipo",
                    accessor: d => d.tipo, 
                    show: true,
                    Filter: ({ filter, onChange }) => (
                        <ParadigmaAsyncSeeker
                            url={undefined}
                            optionDefault={[
                                { id: "VE", nombre: "VENTA" },
                                { id: "SE", nombre: "SERVICIO" },
                                { id: "ES", nombre: "ESCRITURA" },
                                { id: "GA", nombre: "GASTOS" },
                            ]}
                            value={filter ? filter.value : ""}
                            onChange={(e) => onChange(e ? e.id : "")}
                        />
                    ),
                    exportWidth: "25",
                },
                {
                    Header: "Ingresos",
                    id: "ingresos",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => ((d.ingresos > 0) ? `$ ${format(d.ingresos)}` : `$ ${format(0)}`),
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Egresos",
                    id: "egresos",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => ((d.egresos > 0) ? `$ ${format(d.egresos)}` : `$ ${format(0)}`),
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
                {
                    Header: "Sub Total",
                    id: "subtotal",
                    className: 'text-right',
                    exportWidth: "90",
                    accessor: d => ((d.subtotal != 0) ? `$ ${format(d.subtotal)}` : `$ ${format(0)}`),
                    filterable: false,
                    show: true,
                    exportCurrency: true,
                },
            ],
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        detail: true,
                        component: props => <ModalDetalle {...props} action="DETAIL"/>,
                        permission: 'caja_movimientoscaja_detail',
                    },
                ]}
                depth={1}
                apiUrl={api.caja.movimientosAgrupados}
                columns={this.state.columns}
                exportUrl={api.caja.movimientosAgrupados}
                title={"Movimientos Agrupados"}
            />
        );
    }
}

export default MovimientosAgrupados;


// WEBPACK FOOTER //
// ./src/views/Caja/MovimientosAgrupados/MovimientosAgrupados.js